export const WorkflowTemplateOptionFragment = gql`
  fragment WorkflowTemplateOptionFragment on WorkflowTemplate {
    id
    name
    createdAt
    isDeleteable
    isRenewal
  }
`
